import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabId: 'waterCompanies',
};

export const controlSlice = createSlice({
  name: 'control',
  initialState,
  reducers: {
    setTabId: (state, { payload }) => {
      state.tabId = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTabId } = controlSlice.actions;

export default controlSlice.reducer;
